import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, FormControl, Button } from "react-bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import Pagination from "../Whatsapp/Pagination";
import * as XLSX from "xlsx";
import MyContext from "../../MyContext";
import style from "react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark";
import Chaafo from "../../images/chaafo.png";
import WalletTransactionModal from "./WalletTransactionModal";

import { IndianRupee, PlusCircle, MinusCircle, BadgeCheck } from "lucide-react";
const Payment = ({ userID }) => {
  const [loading, setLoading] = useState(false);
  const [Campaign, setCampaign] = useState([]);
  const [processedSettlements, setProcessedSettlements] = useState([]);
  const [settlementInvoices, setSettlementInvoices] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [wallet, setWallet] = useState({});
  const [expandedRow, setExpandedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100;
  const [analyticsData, setAnalyticsData] = useState(null);
  const [noTransaction, setNoTransaction] = useState(false);
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [activeTab, setActiveTab] = useState("successfullOrder");
  const [SettlementCharges, setSettlementCharges] = useState([]);
  const [refund_report, setRefund_report] = useState([]);
  const [genFromDate, setGenFromDate] = useState("");
  const [genToDate, setGenToDate] = useState("");
  const [loadingGenerate, setLoadingGenerate] = useState(false);
const [showWalletTxnModal, setShowWalletTxnModal] = useState(false);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [OrderTypeCount, setOrderTypeCount] = useState([]);
  // Allow ranges up to and including 3 months
  const isRangeWithinThreeMonths = (s, e) => {
    if (!s || !e) return true;
    const sd = new Date(s);
    const ed = new Date(e);
    if (isNaN(sd) || isNaN(ed)) return true;
    if (ed < sd) return false; // invalid: end before start

    const limit = new Date(sd);
    limit.setMonth(limit.getMonth() + 3); // add 3 months to start
    return ed <= limit; // block if end exceeds +3 months
  };

  // Settlement Invoices (NEW)
  const getSettlementInvoicesApi = async () => {
    try {
      setLoading(true);

      const cfg = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${BASIC_AUTH}`,
        },
      };

      const payload = { userid: userID };

      const res = await axios.post(
        `https://api.anlook.com/api/Order/v1.0/getSettlementInvoices`,
        payload,
        cfg
      );

      if (res?.data?.responseCode === "00" && Array.isArray(res.data.response)) {
        setSettlementInvoices(res.data.response);
      } else {
        setSettlementInvoices([]);
      }
    } catch (error) {
      console.log("getSettlementInvoicesApi error:", error);
      setSettlementInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  // fetching the campaigns using the Anlook api.
  let BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";

  const walletBalanceApi = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${BASIC_AUTH}`,
        },
      };
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Transactions/getWalletDetails`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setWallet(response.data.response);
      } else {
      }
    } catch { }
  };
  const processedSettlementsApi = async () => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${BASIC_AUTH}`,
        },
      };

      const raw = {
        userid: userID,
        fromDate: startDate,
        toDate: endDate,
      };

      const res = await axios.post(
        `${baseUrl}/api/Transactions/v1.0/getProcessedSettlements`,
        raw,
        config
      );

      if (res.data?.responseCode === "00" && res.data.response.length > 0) {
        setProcessedSettlements(res.data.response);
      } else {
        setProcessedSettlements([]); // Clear old data when no new data found
      }
    } catch (error) {
      console.log({ error });
      setProcessedSettlements([]); // Clear on error too
    } finally {
      setLoading(false);
    }
  };

  const RefundReportApi = async () => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${BASIC_AUTH}`,
        },
      };

      const raw = {
        userid: userID,

      };

      const res = await axios.post(
        `${baseUrl}/api/Transactions/v1.0/getRefundReport`,
        raw,
        config
      );

      if (res.data?.responseCode === "00" && res.data.response.length > 0) {
        setRefund_report(res.data.response);
      } else {
        setRefund_report([]); // Clear old data when no new data found
      }
    } catch (error) {
      console.log({ error });
      setRefund_report([]); // Clear on error too
    } finally {
      setLoading(false);
    }
  };

  const transactionsReportApi = async () => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${BASIC_AUTH}`,
        },
      };

      const raw = {
        userid: userID,
        fromDate: startDate,
        toDate: endDate,
      };

      const res = await axios.post(
        `${baseUrl}/api/Transactions/getTransactionsReport`,
        raw,
        config
      );

      if (res.data?.responseCode === "00" && res.data.response.length > 0) {
        setCampaign(res.data.response);
      } else {
        setCampaign([]); // Clear old data when no new data found
      }
    } catch (error) {
      console.log({ error });
      setCampaign([]); // Clear on error too
    } finally {
      setLoading(false);
    }
  };



  // const filteredCampaign = Campaign.filter((item) => {
  //   if (activeTab === "un-successfullOrder") {
  //     return item.category === "incomplete_order";
  //   }
  //   return item.category !== "incomplete_order";
  // });

  const filteredCampaign = Campaign.filter((item) => {
    if (activeTab === "un-successfullOrder") {
      return item.category === "incomplete_order";
    } else if (activeTab === "packky_assignment") {
      return item.category === "packky_assignment";
    } else if (activeTab === "cashSuccessfullOrder") {
      return item.payment_mode === "cash" && item.category !== "incomplete_order";
    } else if (activeTab === "qrSuccessfullOrder") {
      // 🔍 only QR transactions
      return item.payment_mode === "QR" && item.category !== "incomplete_order";
    } else if (activeTab === "creditSuccessfullOrder") {
      // 🔍 only CREDIT transactions
      return item.payment_mode === "credit" && item.category !== "incomplete_order";
    }

    // default → UPI successfull orders
    return item.category !== "incomplete_order" && item.payment_mode === "UPI";
  });


  const totalPages = Math.ceil(filteredCampaign.length / itemsPerPage);

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const sortedCampaign = [...filteredCampaign].sort(
    (a, b) => new Date(b.datetime) - new Date(a.datetime)
  );

  const displayedItems = sortedCampaign.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const transactionsAnalyticsApi = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${BASIC_AUTH}`,
        },
      };

      const requestBody = {
        userid: userID,
        fromDate: startDate,
        toDate: endDate,
      };

      const response = await axios.post(
        `${baseUrl}/api/Transactions/v1.0/getTransactionsAnalytics`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setAnalyticsData(response.data.response);
        setNoTransaction(false);
      } else if (response.data.responseCode === "01") {
        setAnalyticsData(null);
        setNoTransaction(true);
      }
    } catch (error) {
      console.error("Error fetching analytics data:", error);
    }
  };
  const OrderTypeCountApi = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${BASIC_AUTH}`,
        },
      };

      const requestBody = {
        userid: userID,
        fromDate: startDate,
        toDate: endDate,
      };

      const response = await axios.post(
        `${baseUrl}/api/Admin/v2.0/getClientOrderSummaryDetails`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setOrderTypeCount(response.data.response);

      } else if (response.data.responseCode === "01") {
        setOrderTypeCount([]);
        // setNoTransaction(true);
      }
    } catch (error) {
      console.error("Error fetching analytics data:", error);
    }
  };
  const GetSettlementChargesApi = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${BASIC_AUTH}`,
        },
      };

      const requestBody = {
        userid: userID,
        fromDate: startDate,
        toDate: endDate,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getSettlementCharges`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setSettlementCharges(response.data.response);

      } else if (response.data.responseCode === "01") {
        setSettlementCharges([]);
        // setNoTransaction(true);
      }
    } catch (error) {
      console.error("Error fetching analytics data:", error);
    }
  };
  useEffect(() => {
    walletBalanceApi();
    setStartDate(getCurrentDate()); // Set today's date
    setEndDate(getCurrentDate()); // Set today's date
  }, []);

  useEffect(() => {
    if (!startDate || !endDate) return;

    // block too-wide ranges
    if (!isRangeWithinThreeMonths(startDate, endDate)) {
      toast.error("Please select a date range up to 3 months.");
      return; // do NOT call the APIs
    }

    // safe to call
    transactionsReportApi();
    transactionsAnalyticsApi();
    processedSettlementsApi();
    OrderTypeCountApi();
    GetSettlementChargesApi();
    RefundReportApi();
    getSettlementInvoicesApi();
  }, [startDate, endDate]);
  // Download / Print Settlement Invoice (opens in new tab; user can Save as PDF)
  const downloadSettlementInvoice = (inv) => {
    const safe = (v) => (v === null || v === undefined ? "" : String(v));

    // Core mapping
    const clientName = safe(inv.organization_name) || "Client";
    const invoiceName = safe(inv.invoice_name);
    const invoiceNumber = safe(inv.invoice_number);
    const fromDate = safe(inv.from_date);
    const toDate = safe(inv.to_date);
    const generatedOn = safe(inv.in_date);
    const gstType = safe(inv.gst_type); // incl/excl
    const gst = safe(inv.gst); // incl/excl
    const status =
      safe(inv.settlement_status).toUpperCase() === "Y" ? "SETTLED" : "UNSETTLED";

    // Amount fields
    const orderAmount = safe(inv.order_amount);
    const settlementAmount = safe(inv.settlement_amount);
    const totalFoodGst = safe(inv.total_food_gst);
    const messagingCharge = safe(inv.messaging_charge);
    const platformCharge = safe(inv.platform_charge);
    const platformChargeTax = safe(inv.platform_charge_tax);
    const deliveryFee = safe(inv.delivery_fee);
    const grossAmount = safe(inv.gross_amount);

    // Logos
    const clientLogo = safe(inv.brand_image); // base64 (data:image/..)
    const chaafoLogo = Chaafo; // imported png

    // Static + Chaafo GST
    const staticInvoiceId = "hadijksfiwbcvewqhoiuc";
    const chaafoGST = "09AAKCC2923R1Z1";

    // Professional Summary (top)
    const summaryText = `Settlement invoice for ${clientName} for period ${fromDate} to ${toDate}. Order amount ${orderAmount}, deductions applied as below, final settlement amount ${settlementAmount}.`;

    const html = `<!doctype html>
<html>
<head>
<meta charset="utf-8"/>
<title>Settlement Invoice ${invoiceNumber}</title>
<meta name="viewport" content="width=device-width, initial-scale=1"/>
<style>
  *{box-sizing:border-box}
  body{margin:0;font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,Arial;background:#fff;color:#0f172a}
  .page{width:840px;margin:0 auto;padding:26px 24px 40px}
  .header{display:flex;justify-content:space-between;gap:18px;align-items:flex-start}
  .block{display:flex;gap:12px;align-items:flex-start;min-width:0}
  .logoBox{width:44px;height:44px;border-radius:12px;overflow:hidden;background:#f1f5f9;border:1px solid #e2e8f0;display:flex;align-items:center;justify-content:center;flex:0 0 auto}
  .logoBox img{width:100%;height:100%;object-fit:cover}
  /* Chaafo logo - do NOT crop/circle */
  .chaafoLogo{
    height:28px;
    width:auto;
    max-width:120px; /* prevents stretching long */
    object-fit:contain;
    display:block;
  }
  .hTitle{font-weight:900;font-size:14px;line-height:1.2}
  .hMeta{font-size:12px;color:#334155;line-height:1.35;margin-top:4px}
  .right{text-align:right}
  .topBar{display:flex;justify-content:space-between;gap:14px;align-items:flex-start;margin:18px 0 14px}
  .title{font-size:22px;font-weight:950;margin:0}
  .sub{font-size:12px;color:#64748b;margin-top:4px}
  .pill{display:inline-flex;align-items:center;gap:8px;border:1px solid #e2e8f0;background:#f8fafc;padding:8px 10px;border-radius:999px;font-size:12px;color:#0f172a;white-space:nowrap}
  .status{font-weight:900}
  .status.ok{color:#16a34a}
  .status.bad{color:#b45309}
  .summary{border:1px solid #e2e8f0;background:#f8fafc;border-radius:16px;padding:14px;margin-bottom:14px}
  .summary h3{margin:0 0 6px;font-size:13px;font-weight:950}
  .summary p{margin:0;font-size:12.5px;color:#334155;line-height:1.45}
  .card{border:1px solid #e2e8f0;border-radius:16px;padding:16px;background:#fff}
  .grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-top:12px}
  .kv{border:1px solid #e2e8f0;background:#f8fafc;border-radius:14px;padding:12px}
  .kv .k{font-size:11px;color:#64748b}
  .kv .v{font-size:13px;font-weight:900;margin-top:4px;color:#0f172a;word-break:break-word}
  .table{width:100%;border-collapse:collapse;margin-top:14px;border-radius:14px;overflow:hidden;border:1px solid #e2e8f0}
  .table thead th{background:#f1f5f9;text-align:left;padding:10px 12px;font-size:12px;color:#0f172a;border-bottom:1px solid #e2e8f0}
  .table tbody td{padding:10px 12px;font-size:12.5px;border-bottom:1px solid #eef2f7}
  .table tbody tr:last-child td{border-bottom:none}
  .num{text-align:right;font-variant-numeric:tabular-nums}
  .sumBox{margin-top:14px;display:grid;grid-template-columns:1fr 330px;gap:14px;align-items:start}
  .totals{border:1px solid #e2e8f0;border-radius:14px;padding:12px;background:#fff}
  .row{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px dashed #e2e8f0;font-size:12.5px}
  .row:last-child{border-bottom:none}
  .row strong{font-weight:950}
  .grand{font-size:14px}
  .footer{text-align:center;margin-top:16px;font-size:12px;color:#475569}
  .muted{color:#64748b}
  @media print{.page{width:auto;margin:0}}
</style>
</head>

<body>
  <div class="page">
    <!-- HEADER -->
    <div class="header">
      <!-- LEFT: CLIENT -->
      <div class="block">
        <div class="logoBox">
          ${clientLogo ? `<img src="${clientLogo}" alt="Client Logo"/>` : ""}
        </div>
        <div style="min-width:0;">
          <div class="hTitle">${clientName}</div>
          
          <div class="hMeta">
          <div><span class="muted">GST No:</span> <b>${gst}</b></div>
            <div>${invoiceName}</div>
            <div class="muted">Settlement period: ${fromDate} → ${toDate}</div>
          </div>
        </div>
      </div>

      <!-- RIGHT: CHAAFO (logo like before, not circle) -->
      <div class="block" style="justify-content:flex-end;">
        <div style="min-width:0;" class="right">
          <div class="hTitle">Chaafo</div>
          <div class="hMeta">
            <div><span class="muted">Invoice ID:</span> <b>${staticInvoiceId}</b></div>
            <div><span class="muted">Invoice No:</span> <b>${invoiceNumber}</b></div>
            <div><span class="muted">GST No:</span> <b>${chaafoGST}</b></div>
            <div><span class="muted">Generated:</span> ${generatedOn}</div>
          </div>
        </div>
        <div style="padding-left:10px;display:flex;align-items:flex-start;">
          <img src="${chaafoLogo}" alt="Chaafo Logo" class="chaafoLogo"/>
        </div>
      </div>
    </div>

    <!-- TOP BAR -->
    <div class="topBar">
      <div>
        <h1 class="title">Settlement Invoice</h1>
        <div class="sub">Summary and detailed deduction breakdown.</div>
      </div>
      <div class="pill">
        <span class="muted">Status:</span>
        <span class="status ${status === "SETTLED" ? "ok" : "bad"}">${status}</span>
      </div>
    </div>

    <!-- PROFESSIONAL SUMMARY -->
    <div class="summary">
      <h3>Summary</h3>
      <p>${summaryText}</p>
    </div>

    <!-- MAIN CARD -->
    <div class="card">
      <div class="grid">
        <div class="kv">
          <div class="k">Settlement Period</div>
          <div class="v">${fromDate} → ${toDate}</div>
        </div>
        <div class="kv">
          <div class="k">GST Type</div>
          <div class="v">${gstType || "-"}</div>
        </div>
        <div class="kv">
          <div class="k">Invoice Number</div>
          <div class="v">${invoiceNumber}</div>
        </div>
        <div class="kv">
          <div class="k">Invoice Name</div>
          <div class="v">${invoiceName || "-"}</div>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th style="width:60px;">#</th>
            <th>Particulars</th>
            <th class="num" style="width:190px;">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Order Amount</td><td class="num">${orderAmount}</td></tr>
          <tr><td>2</td><td>Gross Amount</td><td class="num">${grossAmount}</td></tr>

          <tr><td>3</td><td>Platform Charge</td><td class="num">-${platformCharge}</td></tr>
          <tr><td>4</td><td>Platform Charge Tax</td><td class="num">-${platformChargeTax}</td></tr>
          
          <tr><td>6</td><td>Messaging Charge</td><td class="num">-${messagingCharge}</td></tr>
          <tr><td>7</td><td>Total Food GST</td><td class="num">-${totalFoodGst}</td></tr>
        </tbody>
      </table>

      <div class="sumBox">
        <div class="totals" style="border-style:solid;background:#fff;">
          <div class="row"><span>Order Amount</span><span class="num">${orderAmount}</span></div>
          <div class="row"><span>Total Food GST</span><span class="num">-${totalFoodGst}</span></div>
          <div class="row"><span>Gross Amount</span><span class="num">${grossAmount}</span></div>

          <div class="row"><span>Platform Charge</span><span class="num">-${platformCharge}</span></div>
          <div class="row"><span>Platform Charge Tax</span><span class="num">-${platformChargeTax}</span></div>
          <div class="row"><span>Messaging Charge</span><span class="num">-${messagingCharge}</span></div>
          

          <div class="row grand"><strong>Settlement Amount</strong><strong class="num">${settlementAmount}</strong></div>
        </div>

        <div class="totals">
          <div class="row"><span>Generated On</span><span class="num">${generatedOn || "-"}</span></div>
          <div class="row"><span>Status</span><span class="num"><strong>${status}</strong></span></div>
          <div class="row"><span>Invoice ID</span><span class="num">${invoiceNumber}</span></div>
          <div class="row"><span>Chaafo GST</span><span class="num">${chaafoGST}</span></div>
        </div>
      </div>

      <div class="footer">
        Thank you for your business! <span class="muted">•</span> Managed by Chaafo
      </div>
    </div>

    <script>
      window.onload = function () {
        window.focus();
        window.print();
      };
    </script>
  </div>
</body>
</html>`;

    const w = window.open("", "_blank");
    if (!w) {
      alert("Popup blocked. Please allow popups for this site.");
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
  };


  const generateSettlementInvoicesApi = async () => {
    if (!genFromDate || !genToDate) {
      toast.error("Please select From Date and To Date.");
      return;
    }

    setLoadingGenerate(true);
    try {
      const cfg = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${BASIC_AUTH}`, // keep same as your other APIs
        },
      };

      const payload = {
        userid: String(userID),
        fromDate: String(genFromDate),
        toDate: String(genToDate),
      };

      const res = await axios.post(
        "https://api.anlook.com/api/Order/v1.0/generateSettlementInvoices",
        payload,
        cfg
      );

      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Invoices generated successfully.");
        // refresh list
        getSettlementInvoicesApi();
      } else {
        toast.error(res?.data?.responseMessage || "Failed to generate invoices.");
      }
    } catch (err) {
      console.log("generateSettlementInvoicesApi error:", err);
      toast.error("Error generating invoices.");
    } finally {
      setLoadingGenerate(false);
    }
  };


  const downloadExcel = () => {
    if (!Campaign || Campaign.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Data Found",
        text: "There is no data available to download.",
      });
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(Campaign);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
    XLSX.writeFile(workbook, "Transactions_Report.xlsx");
  };
  // WhatsApp Campaign Charges Section code 
  const [WhatsappNumbers, setWhatsappNumbers] = useState([]);
  const [MultiplePhoneNumber, setMultiplePhoneNumber] = useState(false);
  const [SingleWhatsApp, setSingleWhatsApp] = useState("");
  const [templates, setTemplates] = useState([]);
  const getWhatsappNumber = async () => {
    try {
      const raw = JSON.stringify({ userid: userID });
      const requestOptions = { method: "POST", headers: config.headers, body: raw, redirect: "follow" };
      const res = await fetch(`${baseUrl}/api/Whatsapp/v1.0/getWhatsappNumbers`, requestOptions);
      const data = await res.json();
      if (data?.responseCode === "00") setWhatsappNumbers(data?.response);
    } catch (error) { }
  };
  const getCampaign = async () => {
    try {
      setLoading(true);
      const raw = JSON.stringify({ userid: userID, campaignName: "string", phoneNumberId: SingleWhatsApp });
      const requestOptions = { method: "POST", headers: config.headers, body: raw, redirect: "follow" };
      const res = await fetch(`${baseUrl}/api/Campaign/v1.0/getCampaigns`, requestOptions);
      const data = await res.json();
      if (data?.responseCode === "00") setCampaign(data?.data);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };
  const getTemplates = async () => {
    try {
      const raw = JSON.stringify({ userid: userID, phoneNumberId: SingleWhatsApp });
      const requestOptions = { method: "POST", headers: config.headers, body: raw, redirect: "follow" };
      const res = await fetch(`${baseUrl}/api/Whatsapp/v1.0/getTemplates`, requestOptions);
      const data = await res.json();
      if (data?.responseCode === "00") setTemplates(data?.response.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };
  useEffect(() => {
    console.log(activeTab);
    if (activeTab === "CampaigningCharge") {

      getWhatsappNumber();
    }
  }, [activeTab]);
  useEffect(() => {
    if (WhatsappNumbers && WhatsappNumbers.length === 1) {
      setMultiplePhoneNumber(false);
      WhatsappNumbers.forEach((Num) => setSingleWhatsApp(Num.phone_no_id));
    } else if (WhatsappNumbers && WhatsappNumbers.length !== 1) {
      setMultiplePhoneNumber(true);
      WhatsappNumbers.forEach((Num, i) => (i === 0 ? setSingleWhatsApp(Num.phone_no_id) : ""));
    }
  }, [WhatsappNumbers]);

  useEffect(() => {
    if (!SingleWhatsApp) return;
    getCampaign();
    getTemplates();
  }, [SingleWhatsApp]);
  const twoDecimalPlaces = (value) => {
    return Number(value).toFixed(2).toString();
  };
  // ===== Helpers =====
  const inr = (v) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 })
      .format(Number(v || 0));

  const prettyLabel = (s = "") =>
    s.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase());

  const toneForType = (t) => (String(t) === "1" ? "credit" : String(t) === "2" ? "debit" : "net");
  const iconForType = (t) =>
    String(t) === "1" ? <PlusCircle size={16} /> : String(t) === "2" ? <MinusCircle size={16} /> : <IndianRupee size={16} />;

  // ===== Mini Card Component =====
  const SettlementMiniCards = ({ items = [] }) => {
    if (!items?.length) return <div className="text-muted small">No settlement data.</div>;

    // Order: net first (type 0), then credits (1), then debits (2)
    const ordered = [
      ...items.filter((x) => String(x.type) === "0"),
      ...items.filter((x) => String(x.type) === "1"),
      ...items.filter((x) => String(x.type) === "2"),
    ];

    return (
      <div className="admin-mini-wrap d-flex flex-wrap gap-2 mb-2">
        {ordered.map((it, i) => {
          const tone = toneForType(it.type);
          return (
            <div
              key={`${it.label}-${i}`}
              className={`admin-mini-card admin-mini-${tone}`}
              title={`${prettyLabel(it.label)}: ${inr(it.value)}`}
            >
              <div className="admin-mini-top">
                <span className="admin-mini-icon">{iconForType(it.type)}</span>
                <span className="admin-mini-label">{prettyLabel(it.label)}</span>
              </div>
              <div className="admin-mini-bottom">
                <span className="admin-mini-amount">
                  {/* <IndianRupee size={14} /> */}
                  {inr(it.value)}
                </span>
                <span className={`admin-mini-type admin-mini-type--${tone}`}>
                  {tone === "credit" ? "Credit" : tone === "debit" ? "Debit" : "Net"}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  useEffect(() => {
    // set defaults only once (optional)
    if (!genFromDate && !genToDate) {
      const today = new Date();
      const to = today.toISOString().slice(0, 10);
      const fromDt = new Date(today);
      fromDt.setDate(fromDt.getDate() - 7);
      const from = fromDt.toISOString().slice(0, 10);
      setGenFromDate(from);
      setGenToDate(to);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  return (
    <>
      <div className="d-flex justify-content-center text-center">
        <ToastContainer />
      </div>
      <div>
        <div
          className="p-4 bg-white"
          style={{
            height: "100vh",
            fontFamily: "Nunito,sans-serif",
          }}
        >
          <div className="px-4 justify-content-center">
            <Form className="d-flex justify-content-between pb-4">
              <Form.Label className="CreateCampaign">Payment Report</Form.Label>
              <div className="d-flex justify-content-end gap-3">
                <div className="d-flex justify-content-center align-items-center">
           <div
  className=" bg-light px-2 border-15-only d-flex justify-content-center align-items-center py-2 "
  role="button"
  title="View wallet transactions"
  style={{ cursor: "pointer" }}
  onClick={() => setShowWalletTxnModal(true)}
>
  <span className="text-dark single-line-css">
    Wallet Balance :{" "}
    <span className="ms-2 text-3-2 text-success ">
      ₹ {parseFloat(wallet.walletBalance || 0.0).toFixed(2)}
    </span>
  </span>
</div>

                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <div className=" bg-light px-2 border-15-only d-flex justify-content-center align-items-center py-2 ">
                    <span className="text-dark single-line-css">
                      Unsettled Amount :{" "}
                      <span className="ms-2 text-3-2 text-success ">
                        ₹ {parseFloat(wallet.unsettledAmount || 0.0).toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  {/* <label
                    htmlFor="start-date"
                    className="single-line-css d-flex align-items-center"
                  >
                    Start Date
                  </label> */}
                  <FormControl
                    type="date"
                    id="start-date"
                    value={startDate}
                    className="bg-light"
                    onChange={(e) => {
                      const v = e.target.value;
                      // if endDate exists and is before new start, align it
                      if (endDate && new Date(endDate) < new Date(v)) {
                        setEndDate(v);
                        toast.info("End date adjusted to match the new Start date.");
                      }
                      setStartDate(v);
                    }}
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  {/* <label
                    htmlFor="end-date"
                    className="single-line-css d-flex align-items-center"
                  >
                    End Date
                  </label> */}
                  <FormControl
                    type="date"
                    id="end-date"
                    value={endDate}
                    className="bg-light"
                    onChange={(e) => {
                      const v = e.target.value;
                      if (startDate && new Date(v) < new Date(startDate)) {
                        toast.error("End date cannot be before Start date.");
                        return; // reject change
                      }
                      setEndDate(v);
                    }}
                  />
                </div>
                <div className="d-flex align-items-center">
                  <Button onClick={downloadExcel} disabled={!isRangeWithinThreeMonths(startDate, endDate)}>
                    Download
                  </Button>
                </div>
              </div>
            </Form>
            <div className="d-flex flex-wrap gap-4 justify-content-between mb-4">

              {noTransaction ? (
                <>
                  {/* 1) Total/Settlement */}
                  <div className="card border-0 rounded-4 bg-light flex-fill h-100" style={{ minWidth: "300px" }}>
                    <div className="card-body p-3">
                      <div className="d-flex justify-content-between mb-2">
                        <div>
                          <h6 className="text-muted mb-1">Total Order Amount</h6>
                          <h5 className="text-primary fw-bold">₹ 0.00</h5>
                        </div>
                        <div className="vr mx-3"></div>
                        <div>
                          <h6 className="text-muted mb-1">Settlement Amount</h6>
                          <h5 className="text-success fw-bold">₹ 0.00</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 2) Platform / Delivery (replacing Message Charges) */}
                  <div className="card border-0 rounded-4 bg-light flex-fill h-100" style={{ minWidth: "300px" }}>
                    <div className="card-body p-3">
                      <div className="d-flex justify-content-between mb-2">
                        <div>
                          <h6 className="text-muted mb-1">Platform Charges</h6>
                          <h5 className="text-info fw-bold">₹ 0.00</h5>
                        </div>
                        <div className="vr mx-3"></div>
                        <div>
                          <h6 className="text-muted mb-1">Delivery Charges</h6>
                          <h5 className="text-primary fw-bold">₹ 0.00</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 3) Messages / Per Msg Cost / Message Charges (added here) */}
                  <div className="card border-0 rounded-4 bg-light flex-fill h-100" style={{ minWidth: "300px" }}>
                    <div className="card-body p-3">
                      <div className="admin-metric-3 d-flex text-center">
                        <div className="flex-fill">
                          <h6 className="text-muted mb-1">Total Messages</h6>
                          <h5 className="text-success fw-bold mb-0">0</h5>
                        </div>
                        <div className="admin-divider-x"></div>
                        <div className="flex-fill">
                          <h6 className="text-muted mb-1">Per Message Cost</h6>
                          <h5 className="text-info fw-bold mb-0">₹ 0.00</h5>
                        </div>
                        <div className="admin-divider-x"></div>
                        <div className="flex-fill">
                          <h6 className="text-muted mb-1">Message Charges</h6>
                          <h5 className="text-primary fw-bold mb-0">₹ 0.00</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : analyticsData ? (
                <>
                  {/* Helper for clean currency formatting */}
                  {/* If you prefer, lift this function out of JSX scope */}
                  {(() => {
                    const fmt = (n) => parseFloat(n || 0).toFixed(2);
                    return (
                      <>
                        {/* 1) Total/Settlement */}
                        <div className="card border-0 rounded-4 bg-white flex-fill h-100" style={{ minWidth: "300px" }}>
                          <div className="card-body p-3">
                            <div className="d-flex justify-content-between mb-2">
                              <div>
                                <h6 className="text-muted mb-1">Total Order Amount</h6>
                                <h5 className="text-primary fw-bold">₹ {fmt(analyticsData.totalOrderAmount)}</h5>
                              </div>
                              <div className="vr mx-3"></div>
                              <div>
                                <h6 className="text-muted mb-1">Settlement Amount</h6>
                                <h5 className="text-success fw-bold">₹ {fmt(analyticsData.totalSettlementAmount)}</h5>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* 2) Platform / Delivery (Message Charges moved out) */}
                        <div className="card border-0 rounded-4 bg-white flex-fill h-100" style={{ minWidth: "300px" }}>
                          <div className="card-body p-3">
                            <div className="d-flex justify-content-between mb-2">
                              <div>
                                <h6 className="text-muted mb-1">Platform Charges</h6>
                                <h5 className="text-info fw-bold">₹ {fmt(analyticsData.totalPlatformCharges)}</h5>
                              </div>
                              <div className="vr mx-3"></div>
                              <div>
                                <h6 className="text-muted mb-1">Delivery Charges</h6>
                                <h5 className="text-primary fw-bold">₹ {fmt(analyticsData.totalDeliveryCharges)}</h5>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* 3) Messages / Per Msg Cost / Message Charges (nicely grouped) */}
                        <div className="card border-0 rounded-4 bg-white flex-fill h-100" style={{ minWidth: "300px" }}>
                          <div className="card-body p-3">
                            <div className="admin-metric-3 d-flex text-center">
                              <div className="flex-fill">
                                <h6 className="text-muted mb-1">Total Messages</h6>
                                <h5 className="text-success fw-bold mb-0">{analyticsData.totalMessages || 0}</h5>
                              </div>
                              <div className="admin-divider-x"></div>
                              <div className="flex-fill">
                                <h6 className="text-muted mb-1">Per Message Cost</h6>
                                <h5 className="text-info fw-bold mb-0">₹ {fmt(analyticsData.perMessageCost)}</h5>
                              </div>
                              <div className="admin-divider-x"></div>
                              <div className="flex-fill">
                                <h6 className="text-muted mb-1">Message Charges</h6>
                                <h5 className="text-primary fw-bold mb-0">₹ {fmt(analyticsData.totalMessageCharges)}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })()}
                </>
              ) : null}

            </div>
            {SettlementCharges && <SettlementMiniCards items={SettlementCharges} />}
            {/* {JSON.stringify(SettlementCharges)} */}

            {/* Badges for OrderTypeCount */}
            {OrderTypeCountApi && Array.isArray(OrderTypeCount) && OrderTypeCount.length > 0 && (
              <div className="d-flex flex-column gap-2 mb-2">
                {OrderTypeCount.map(({ clientName, orderTypes }, idx) => (
                  <div key={clientName || idx} className="d-flex align-items-start justify-content-between flex-wrap gap-2 border rounded-3 p-2">
                    {/* Client name */}
                    <div className="fw-semibold small">{clientName || "—"}</div>

                    {/* Order type badges */}
                    <div className="d-flex flex-wrap gap-2">
                      {(orderTypes || []).map(({ orderType, orderCount }, i) => {
                        const label = (orderType || "").replace(/_/g, " ");
                        // choose a color per type (fallback to secondary)
                        const color =
                          orderType === "home_delivery" ? "primary" :
                            orderType === "takeaway" ? "success" :
                              orderType === "dine_in" ? "info" :
                                "secondary";

                        return (
                          <span
                            key={`${orderType}-${i}`}
                            className={`badge rounded-pill text-bg-${color} d-flex align-items-center gap-1`}
                            style={{ fontSize: "0.75rem", padding: "0.4rem 0.6rem" }}
                            title={`${label}: ${orderCount}`}
                          >
                            <span className="text-capitalize">{label}</span>
                            <span className="badge text-bg-light ms-1" style={{ fontSize: "0.7rem" }}>
                              {orderCount}
                            </span>
                          </span>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            )}


            {OrderTypeCountApi && (!Array.isArray(OrderTypeCount) || OrderTypeCount.length === 0) && (
              <div className="text-muted small">No order types found.</div>
            )}


            <div>
              <ul className="nav nav-tabs mb-4 bg-light p-2 rounded ">
                {[
                  { key: "successfullOrder", label: "UPI Orders" },
                  { key: "cashSuccessfullOrder", label: "Cash Orders" },
                  { key: "qrSuccessfullOrder", label: "QR Orders" },        // 🆕
                  { key: "creditSuccessfullOrder", label: "Credit Orders" },// 🆕
                  {
                    key: "un-successfullOrder",
                    label: "Un-Successfull Orders",
                  },
                  {
                    key: "ProcessedSettlements",
                    label: "Processed Settlements",
                  },
                  {
                    key: "packky_assignment",
                    label: "Assign To Packky",
                  },
                  {
                    key: "CampaigningCharge",
                    label: "Campaigning Charge",
                  },
                  {
                    key: "refund_report",
                    label: "Refunds",
                  },
                ].map((tab) => (
                  <li className="nav-item" key={tab.key}>
                    <button
                      className={`nav-link fw-semibold rounded-top px-3 py-2 mx-1 ${activeTab === tab.key
                        ? "active order-section-button bg-green-order  text-white"
                        : "text-dark bg-light"
                        }`}
                      onClick={() => setActiveTab(tab.key)}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>



            {loading ? (
              <div className="m-5 p-5 d-flex justify-content-center">
                <div className="loader"></div>
              </div>
            ) : (
              <>
                {activeTab === "successfullOrder" && (
                  <>
                    <table className="table table-hover">
                      <thead style={{ borderRadius: "10px" }}>
                        <tr
                          className="text-center"
                          style={{
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              borderRadius: "7px 0px 0px 7px",
                              fontSize: "0.95rem",
                            }}
                          >
                            S.No.
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Date
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Reference No.
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Order Type
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Order ID
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Customer Name
                          </th>

                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            <span className="single-line-css">
                              Order Amount
                            </span>
                            <div
                              className=" single-line-css"
                              style={{
                                fontSize: "0.8rem", // Smaller text size
                                fontWeight: "bold", // Bold font
                                opacity: 1, // Slightly lower opacity for a more professional look
                              }}
                            >
                              (GST included)
                            </div>
                          </th>

                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Net Charges <br />
                            Deduction
                          </th>

                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Net Settlement
                            <div>Amount</div>
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              borderRadius: "0px 7px 7px 0px",
                              fontSize: "0.95rem",
                            }}
                          >
                            Settlement
                            <br /> Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedItems.length === 0 ? (
                          <>
                            {loading ? (
                              <tr>
                                <td colSpan="10" className="text-center py-5">
                                  <div className="m-5 p-5 d-flex justify-content-center">
                                    <div className="loader"></div>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center py-3">
                                  No Payment Records Found for Selected Date!
                                </td>
                              </tr>
                            )}
                          </>
                        ) : (
                          displayedItems.map((item, index) => (
                            <React.Fragment key={index}>
                              <tr
                                style={{
                                  borderBottom: "1px solid #DDD",
                                  padding: "5px 0px",
                                }}
                              >
                                <td className="p-3 text-center align-middle">
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.datetime}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.rrn}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.order_type
                                    ? item.order_type.charAt(0).toUpperCase() +
                                    item.order_type.slice(1)
                                    : "NA"}   <br />
                                  ({item.payment_mode})
                                </td>
                                <td className="p-3 text-center align-middle single-line-css">
                                  {item.refrence}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.customer_name || "NA"}
                                </td>

                                <td className="p-3 text-center align-middle fw-semibold">
                                  ₹ {twoDecimalPlaces(item.credit)}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  <div className="d-flex justify-content-between align-items-center gap-2">
                                    <span className="fw-semibold text-dark single-line-css">
                                      ₹ {twoDecimalPlaces(item.totalDeduction)}
                                    </span>
                                    <button
                                      className={`btn btn-sm text-primary ${expandedRow === item.id ? "" : ""
                                        }`}
                                      onClick={() =>
                                        setExpandedRow(
                                          expandedRow === item.id
                                            ? null
                                            : item.id
                                        )
                                      }
                                    >
                                      {expandedRow === item.id
                                        ? "Hide"
                                        : "Details"}
                                    </button>
                                  </div>
                                </td>
                                <td className="p-3 text-center align-middle">
                                  <strong>₹ {twoDecimalPlaces(item.settlement_amount)}</strong>
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.settlement_status === "Y" ? (
                                    <span
                                      className="text-center w-100 d-inline-block px-3 py-1"
                                      style={{
                                        color: "#0F5132",
                                        backgroundColor: "#D1E7DD",
                                        border: "1px solid #0F5132",
                                        borderRadius: "20px",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Settled
                                    </span>
                                  ) : (
                                    <span
                                      className="text-center w-100 d-inline-block px-3 py-1"
                                      style={{
                                        color: "#000",
                                        backgroundColor: "#fff3cd",
                                        border: "1px solid #000",
                                        borderRadius: "20px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Unsettled
                                    </span>
                                  )}
                                </td>
                              </tr>
                              {expandedRow === item.id && (
                                <tr>
                                  <td
                                    colSpan="10"
                                    className="p-0 bg-light shadow"
                                  >
                                    <div className="mx-3 px-4   ">
                                      {/* Invoice Title */}
                                      <div className="   py-4">
                                        <h5 className="mb-0 text-dark">
                                          Breakdown of Charges Deducted
                                        </h5>
                                      </div>
                                      {/* <hr className="p-0 m-0" /> */}
                                      {/* WhatsApp Messaging Charges */}
                                      <div className="pb-2">
                                        <div className="fw-bold text-uppercase text-muted">
                                          WhatsApp Messaging Charges
                                        </div>

                                        <div className="d-flex justify-content-between">
                                          <span>Messages Sent to Users</span>
                                          <span>
                                            {item.message_count} Message(s)
                                          </span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                          <span>Charge per Message</span>
                                          <span>₹ {twoDecimalPlaces(item.per_message_cost)}</span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                          <span>
                                            Subtotal (Message Charges)
                                          </span>
                                          <span>₹ {twoDecimalPlaces(item.message_charges)}</span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                          <span>GST (Tax)</span>
                                          <span>₹ {twoDecimalPlaces(item.message_gst)}</span>
                                        </div>

                                        <div className="d-flex justify-content-between fw-bold">
                                          <span>Total Messaging Cost</span>
                                          <span>
                                            ₹{" "}
                                            {(
                                              parseFloat(item.message_charges) +
                                              parseFloat(item.message_gst)
                                            ).toFixed(2)}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="p-0 m-0" />
                                      {/* Transaction Charges */}
                                      <div className="py-2">
                                        <div className="fw-bold text-uppercase text-muted ">
                                          Tax Deduction
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span><b>CGST</b></span>
                                          <span>₹ {twoDecimalPlaces(item.cgst)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span><b>SGST</b></span>
                                          <span>₹ {twoDecimalPlaces(item.sgst)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Total GST (Tax)</span>
                                          <span>₹ {twoDecimalPlaces(item.tax_gst)}</span>
                                        </div>
                                      </div>
                                      <hr className="p-0 m-0" />
                                      {/* Transaction Charges */}
                                      <div className="py-2">
                                        <div className="fw-bold text-uppercase text-muted ">
                                          Transaction Charges
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Gateway Charges</span>
                                          <span>₹ {twoDecimalPlaces(item.gateway_charges)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>GST</span>
                                          <span>₹ {twoDecimalPlaces(item.gateway_gst)}</span>
                                        </div>
                                      </div>
                                      <hr className="p-0 m-0" />
                                      {/* Platform Fee */}
                                      <div className="py-2">
                                        <div className="fw-bold text-uppercase text-muted ">
                                          Platform Fee
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Platform Charges</span>
                                          <span>₹ {twoDecimalPlaces(item.charges)}</span>
                                        </div>
                                        {/* <div className="d-flex justify-content-between">
            <span>GST (CGST + SGST)</span>
            <span>₹ {item.tax_gst}</span>
          </div> */}
                                      </div>
                                      {item.order_type === "home_delivery" && (
                                        <>
                                          <hr className="p-0 m-0" />
                                          <div className="py-2">
                                            <div className="fw-bold text-uppercase text-muted ">
                                              Order Type : {item.order_type}
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <span>Delivery Fee</span>
                                              <span>₹ {twoDecimalPlaces(item.delivery_fee)}</span>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      <hr className="p-0 m-0" />
                                      {/* Total */}
                                      <h6 className=" py-4 d-flex justify-content-between fw-bold">
                                        <span className="text-primary">
                                          Total Charges Deduction
                                        </span>
                                        <span className="text-primary">
                                          ₹ {twoDecimalPlaces(item.totalDeduction)}
                                        </span>
                                      </h6>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))
                        )}
                      </tbody>
                    </table>
                    <div className="pb-4">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onNextPage={handleNextPage}
                        onPrevPage={handlePrevPage}
                        onPageClick={handlePageClick}
                      />
                    </div>
                  </>
                )}
                {activeTab === "cashSuccessfullOrder" && (
                  <>
                    <table className="table table-hover">
                      <thead style={{ borderRadius: "10px" }}>
                        <tr
                          className="text-center"
                          style={{
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              borderRadius: "7px 0px 0px 7px",
                              fontSize: "0.95rem",
                            }}
                          >
                            S.No.
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Date
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Reference No.
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Order Type
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Order ID
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Customer Name
                          </th>

                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            <span className="single-line-css">
                              Order Amount
                            </span>
                            <div
                              className=" single-line-css"
                              style={{
                                fontSize: "0.8rem", // Smaller text size
                                fontWeight: "bold", // Bold font
                                opacity: 1, // Slightly lower opacity for a more professional look
                              }}
                            >
                              (GST included)
                            </div>
                          </th>

                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Net Charges <br />
                            Deduction
                          </th>

                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Net Settlement
                            <div>Amount</div>
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              borderRadius: "0px 7px 7px 0px",
                              fontSize: "0.95rem",
                            }}
                          >
                            Settlement
                            <br /> Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedItems.length === 0 ? (
                          <>
                            {loading ? (
                              <tr>
                                <td colSpan="10" className="text-center py-5">
                                  <div className="m-5 p-5 d-flex justify-content-center">
                                    <div className="loader"></div>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center py-3">
                                  No Payment Records Found for Selected Date!
                                </td>
                              </tr>
                            )}
                          </>
                        ) : (
                          displayedItems.map((item, index) => (
                            <React.Fragment key={index}>
                              <tr
                                style={{
                                  borderBottom: "1px solid #DDD",
                                  padding: "5px 0px",
                                }}
                              >
                                <td className="p-3 text-center align-middle">
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.datetime}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.rrn}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.order_type
                                    ? item.order_type.charAt(0).toUpperCase() +
                                    item.order_type.slice(1)
                                    : "NA"}
                                  <br />
                                  ({item.payment_mode})
                                </td>
                                <td className="p-3 text-center align-middle single-line-css">
                                  {item.refrence}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.customer_name || "NA"}
                                </td>

                                <td className="p-3 text-center align-middle fw-semibold">
                                  ₹ {twoDecimalPlaces(item.credit)}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  <div className="d-flex justify-content-between align-items-center gap-2">
                                    <span className="fw-semibold text-dark single-line-css">
                                      ₹ {twoDecimalPlaces(item.totalDeduction)}
                                    </span>
                                    <button
                                      className={`btn btn-sm text-primary ${expandedRow === item.id ? "" : ""
                                        }`}
                                      onClick={() =>
                                        setExpandedRow(
                                          expandedRow === item.id
                                            ? null
                                            : item.id
                                        )
                                      }
                                    >
                                      {expandedRow === item.id
                                        ? "Hide"
                                        : "Details"}
                                    </button>
                                  </div>
                                </td>
                                <td className="p-3 text-center align-middle">
                                  <strong>₹ {twoDecimalPlaces(item.settlement_amount)}</strong>
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.settlement_status === "Y" ? (
                                    <span
                                      className="text-center w-100 d-inline-block px-3 py-1"
                                      style={{
                                        color: "#0F5132",
                                        backgroundColor: "#D1E7DD",
                                        border: "1px solid #0F5132",
                                        borderRadius: "20px",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Settled
                                    </span>
                                  ) : (
                                    <span
                                      className="text-center w-100 d-inline-block px-3 py-1"
                                      style={{
                                        color: "#000",
                                        backgroundColor: "#fff3cd",
                                        border: "1px solid #000",
                                        borderRadius: "20px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Unsettled
                                    </span>
                                  )}
                                </td>
                              </tr>
                              {expandedRow === item.id && (
                                <tr>
                                  <td
                                    colSpan="10"
                                    className="p-0 bg-light shadow"
                                  >
                                    <div className="mx-3 px-4   ">
                                      {/* Invoice Title */}
                                      <div className="   py-4">
                                        <h5 className="mb-0 text-dark">
                                          Breakdown of Charges Deducted
                                        </h5>
                                      </div>
                                      {/* <hr className="p-0 m-0" /> */}
                                      {/* WhatsApp Messaging Charges */}
                                      <div className="pb-2">
                                        <div className="fw-bold text-uppercase text-muted">
                                          WhatsApp Messaging Charges
                                        </div>

                                        <div className="d-flex justify-content-between">
                                          <span>Messages Sent to Users</span>
                                          <span>
                                            {item.message_count} Message(s)
                                          </span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                          <span>Charge per Message</span>
                                          <span>₹ {twoDecimalPlaces(item.per_message_cost)}</span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                          <span>
                                            Subtotal (Message Charges)
                                          </span>
                                          <span>₹ {twoDecimalPlaces(item.message_charges)}</span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                          <span>GST (Tax)</span>
                                          <span>₹ {twoDecimalPlaces(item.message_gst)}</span>
                                        </div>

                                        <div className="d-flex justify-content-between fw-bold">
                                          <span>Total Messaging Cost</span>
                                          <span>
                                            ₹{" "}
                                            {(
                                              parseFloat(item.message_charges) +
                                              parseFloat(item.message_gst)
                                            ).toFixed(2)}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="p-0 m-0" />
                                      {/* Transaction Charges */}
                                      <div className="py-2">
                                        <div className="fw-bold text-uppercase text-muted ">
                                          Transaction Charges
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Gateway Charges</span>
                                          <span>₹ {twoDecimalPlaces(item.gateway_charges)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>GST</span>
                                          <span>₹ {item.gateway_gst}</span>
                                        </div>
                                      </div>
                                      <hr className="p-0 m-0" />
                                      {/* Platform Fee */}
                                      <div className="py-2">
                                        <div className="fw-bold text-uppercase text-muted ">
                                          Platform Fee
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Platform Charges</span>
                                          <span>₹ {twoDecimalPlaces(item.charges)}</span>
                                        </div>
                                        {/* <div className="d-flex justify-content-between">
            <span>GST (CGST + SGST)</span>
            <span>₹ {item.tax_gst}</span>
          </div> */}
                                      </div>
                                      {item.order_type === "home_delivery" && (
                                        <>
                                          <hr className="p-0 m-0" />
                                          <div className="py-2">
                                            <div className="fw-bold text-uppercase text-muted ">
                                              Order Type : {item.order_type}
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <span>Delivery Fee</span>
                                              <span>₹ {twoDecimalPlaces(item.delivery_fee)}</span>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      <hr className="p-0 m-0" />
                                      {/* Total */}
                                      <h6 className=" py-4 d-flex justify-content-between fw-bold">
                                        <span className="text-primary">
                                          Total Charges Deduction
                                        </span>
                                        <span className="text-primary">
                                          ₹ {twoDecimalPlaces(item.totalDeduction)}
                                        </span>
                                      </h6>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))
                        )}
                      </tbody>
                    </table>
                    <div className="pb-4">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onNextPage={handleNextPage}
                        onPrevPage={handlePrevPage}
                        onPageClick={handlePageClick}
                      />
                    </div>
                  </>
                )}
                {activeTab === "qrSuccessfullOrder" && (
                  <>
                    <table className="table table-hover">
                      <thead style={{ borderRadius: "10px" }}>
                        <tr
                          className="text-center"
                          style={{
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",
                              borderRadius: "7px 0px 0px 7px",
                              fontSize: "0.95rem",
                            }}
                          >
                            S.No.
                          </th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ color: "#fff", fontSize: "0.95rem" }}>
                            Date
                          </th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ color: "#fff", fontSize: "0.95rem" }}>
                            Reference No.
                          </th>
                          <th className="p-3 align-middle bg-light text-dark single-line-css" style={{ color: "#fff", fontSize: "0.95rem" }}>
                            Order Type
                          </th>
                          <th className="p-3 align-middle bg-light text-dark single-line-css" style={{ color: "#fff", fontSize: "0.95rem" }}>
                            Order ID
                          </th>
                          <th className="p-3 align-middle bg-light text-dark single-line-css" style={{ color: "#fff", fontSize: "0.95rem" }}>
                            Customer Name
                          </th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ color: "#fff", fontSize: "0.95rem" }}>
                            <span className="single-line-css">Order Amount</span>
                            <div
                              className="single-line-css"
                              style={{
                                fontSize: "0.8rem",
                                fontWeight: "bold",
                                opacity: 1,
                              }}
                            >
                              (GST included)
                            </div>
                          </th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ color: "#fff", fontSize: "0.95rem" }}>
                            Net Charges <br />
                            Deduction
                          </th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ color: "#fff", fontSize: "0.95rem" }}>
                            Net Settlement
                            <div>Amount</div>
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",
                              borderRadius: "0px 7px 7px 0px",
                              fontSize: "0.95rem",
                            }}
                          >
                            Settlement
                            <br /> Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedItems.length === 0 ? (
                          <>
                            {loading ? (
                              <tr>
                                <td colSpan="10" className="text-center py-5">
                                  <div className="m-5 p-5 d-flex justify-content-center">
                                    <div className="loader"></div>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center py-3">
                                  No QR Payment Records Found for Selected Date!
                                </td>
                              </tr>
                            )}
                          </>
                        ) : (
                          displayedItems.map((item, index) => (
                            <React.Fragment key={index}>
                              <tr
                                style={{
                                  borderBottom: "1px solid #DDD",
                                  padding: "5px 0px",
                                }}
                              >
                                <td className="p-3 text-center align-middle">
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td className="p-3 text-center align-middle">{item.datetime}</td>
                                <td className="p-3 text-center align-middle">{item.rrn}</td>
                                <td className="p-3 text-center align-middle">
                                  {item.order_type
                                    ? item.order_type.charAt(0).toUpperCase() + item.order_type.slice(1)
                                    : "NA"}{" "}
                                  <br />
                                  ({item.payment_mode})
                                </td>
                                <td className="p-3 text-center align-middle single-line-css">
                                  {item.refrence}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.customer_name || "NA"}
                                </td>
                                <td className="p-3 text-center align-middle fw-semibold">
                                  ₹ {twoDecimalPlaces(item.credit)}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  <div className="d-flex justify-content-between align-items-center gap-2">
                                    <span className="fw-semibold text-dark single-line-css">
                                      ₹ {twoDecimalPlaces(item.totalDeduction)}
                                    </span>
                                    <button
                                      className={`btn btn-sm text-primary ${expandedRow === item.id ? "" : ""}`}
                                      onClick={() =>
                                        setExpandedRow(expandedRow === item.id ? null : item.id)
                                      }
                                    >
                                      {expandedRow === item.id ? "Hide" : "Details"}
                                    </button>
                                  </div>
                                </td>
                                <td className="p-3 text-center align-middle">
                                  <strong>₹ {twoDecimalPlaces(item.settlement_amount)}</strong>
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.settlement_status === "Y" ? (
                                    <span
                                      className="text-center w-100 d-inline-block px-3 py-1"
                                      style={{
                                        color: "#0F5132",
                                        backgroundColor: "#D1E7DD",
                                        border: "1px solid #0F5132",
                                        borderRadius: "20px",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Settled
                                    </span>
                                  ) : (
                                    <span
                                      className="text-center w-100 d-inline-block px-3 py-1"
                                      style={{
                                        color: "#000",
                                        backgroundColor: "#fff3cd",
                                        border: "1px solid #000",
                                        borderRadius: "20px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Unsettled
                                    </span>
                                  )}
                                </td>
                              </tr>

                              {/* same expandedRow breakdown as UPI/Cash */}
                              {expandedRow === item.id && (
                                <tr>
                                  <td colSpan="10" className="p-0 bg-light shadow">
                                    <div className="mx-3 px-4">
                                      <div className="py-4">
                                        <h5 className="mb-0 text-dark">
                                          Breakdown of Charges Deducted
                                        </h5>
                                      </div>

                                      {/* WhatsApp Messaging Charges */}
                                      <div className="pb-2">
                                        <div className="fw-bold text-uppercase text-muted">
                                          WhatsApp Messaging Charges
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Messages Sent to Users</span>
                                          <span>{item.message_count} Message(s)</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Charge per Message</span>
                                          <span>₹ {twoDecimalPlaces(item.per_message_cost)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Subtotal (Message Charges)</span>
                                          <span>₹ {twoDecimalPlaces(item.message_charges)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>GST (Tax)</span>
                                          <span>₹ {twoDecimalPlaces(item.message_gst)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between fw-bold">
                                          <span>Total Messaging Cost</span>
                                          <span>
                                            ₹{" "}
                                            {(
                                              parseFloat(item.message_charges) +
                                              parseFloat(item.message_gst)
                                            ).toFixed(2)}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="p-0 m-0" />

                                      {/* Transaction Charges */}
                                      <div className="py-2">
                                        <div className="fw-bold text-uppercase text-muted ">
                                          Transaction Charges
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Gateway Charges</span>
                                          <span>₹ {twoDecimalPlaces(item.gateway_charges)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>GST</span>
                                          <span>₹ {twoDecimalPlaces(item.gateway_gst)}</span>
                                        </div>
                                      </div>
                                      <hr className="p-0 m-0" />

                                      {/* Platform Fee */}
                                      <div className="py-2">
                                        <div className="fw-bold text-uppercase text-muted ">
                                          Platform Fee
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Platform Charges</span>
                                          <span>₹ {twoDecimalPlaces(item.charges)}</span>
                                        </div>
                                      </div>

                                      {item.order_type === "home_delivery" && (
                                        <>
                                          <hr className="p-0 m-0" />
                                          <div className="py-2">
                                            <div className="fw-bold text-uppercase text-muted ">
                                              Order Type : {item.order_type}
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <span>Delivery Fee</span>
                                              <span>₹ {twoDecimalPlaces(item.delivery_fee)}</span>
                                            </div>
                                          </div>
                                        </>
                                      )}

                                      <hr className="p-0 m-0" />
                                      <h6 className="py-4 d-flex justify-content-between fw-bold">
                                        <span className="text-primary">
                                          Total Charges Deduction
                                        </span>
                                        <span className="text-primary">
                                          ₹ {twoDecimalPlaces(item.totalDeduction)}
                                        </span>
                                      </h6>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))
                        )}
                      </tbody>
                    </table>
                    <div className="pb-4">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onNextPage={handleNextPage}
                        onPrevPage={handlePrevPage}
                        onPageClick={handlePageClick}
                      />
                    </div>
                  </>
                )}
                {activeTab === "creditSuccessfullOrder" && (
                  <>
                    <table className="table table-hover">
                      <thead style={{ borderRadius: "10px" }}>
                        <tr
                          className="text-center"
                          style={{
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",
                              borderRadius: "7px 0px 0px 7px",
                              fontSize: "0.95rem",
                            }}
                          >
                            S.No.
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",
                              fontSize: "0.95rem",
                            }}
                          >
                            Date
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",
                              fontSize: "0.95rem",
                            }}
                          >
                            Reference No.
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",
                              fontSize: "0.95rem",
                            }}
                          >
                            Order Type
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",
                              fontSize: "0.95rem",
                            }}
                          >
                            Order ID
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",
                              fontSize: "0.95rem",
                            }}
                          >
                            Customer Name
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",
                              fontSize: "0.95rem",
                            }}
                          >
                            <span className="single-line-css">Order Amount</span>
                            <div
                              className="single-line-css"
                              style={{
                                fontSize: "0.8rem",
                                fontWeight: "bold",
                                opacity: 1,
                              }}
                            >
                              (GST included)
                            </div>
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",
                              fontSize: "0.95rem",
                            }}
                          >
                            Net Charges <br />
                            Deduction
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",
                              fontSize: "0.95rem",
                            }}
                          >
                            Net Settlement
                            <div>Amount</div>
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",
                              borderRadius: "0px 7px 7px 0px",
                              fontSize: "0.95rem",
                            }}
                          >
                            Settlement
                            <br /> Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedItems.length === 0 ? (
                          <>
                            {loading ? (
                              <tr>
                                <td colSpan="10" className="text-center py-5">
                                  <div className="m-5 p-5 d-flex justify-content-center">
                                    <div className="loader"></div>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center py-3">
                                  No Credit Payment Records Found for Selected Date!
                                </td>
                              </tr>
                            )}
                          </>
                        ) : (
                          displayedItems.map((item, index) => (
                            <React.Fragment key={index}>
                              <tr
                                style={{
                                  borderBottom: "1px solid #DDD",
                                  padding: "5px 0px",
                                }}
                              >
                                <td className="p-3 text-center align-middle">
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.datetime}
                                </td>
                                <td className="p-3 text-center align-middle">{item.rrn}</td>
                                <td className="p-3 text-center align-middle">
                                  {item.order_type
                                    ? item.order_type.charAt(0).toUpperCase() +
                                    item.order_type.slice(1)
                                    : "NA"}{" "}
                                  <br />
                                  ({item.payment_mode})
                                </td>
                                <td className="p-3 text-center align-middle single-line-css">
                                  {item.refrence}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.customer_name || "NA"}
                                </td>
                                <td className="p-3 text-center align-middle fw-semibold">
                                  ₹ {twoDecimalPlaces(item.debit || item.credit)}
                                </td>
                                <td className="p-3 text-center align-middle">
                                  <div className="d-flex justify-content-between align-items-center gap-2">
                                    <span className="fw-semibold text-dark single-line-css">
                                      ₹ {twoDecimalPlaces(item.totalDeduction)}
                                    </span>
                                    <button
                                      className={`btn btn-sm text-primary ${expandedRow === item.id ? "" : ""
                                        }`}
                                      onClick={() =>
                                        setExpandedRow(
                                          expandedRow === item.id ? null : item.id
                                        )
                                      }
                                    >
                                      {expandedRow === item.id ? "Hide" : "Details"}
                                    </button>
                                  </div>
                                </td>
                                <td className="p-3 text-center align-middle">
                                  <strong>
                                    ₹ {twoDecimalPlaces(item.settlement_amount)}
                                  </strong>
                                </td>
                                <td className="p-3 text-center align-middle">
                                  {item.settlement_status === "Y" ? (
                                    <span
                                      className="text-center w-100 d-inline-block px-3 py-1"
                                      style={{
                                        color: "#0F5132",
                                        backgroundColor: "#D1E7DD",
                                        border: "1px solid #0F5132",
                                        borderRadius: "20px",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Settled
                                    </span>
                                  ) : (
                                    <span
                                      className="text-center w-100 d-inline-block px-3 py-1"
                                      style={{
                                        color: "#000",
                                        backgroundColor: "#fff3cd",
                                        border: "1px solid #000",
                                        borderRadius: "20px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Unsettled
                                    </span>
                                  )}
                                </td>
                              </tr>

                              {expandedRow === item.id && (
                                <tr>
                                  <td colSpan="10" className="p-0 bg-light shadow">
                                    <div className="mx-3 px-4">
                                      <div className="py-4">
                                        <h5 className="mb-0 text-dark">
                                          Breakdown of Charges Deducted
                                        </h5>
                                      </div>

                                      {/* WhatsApp Messaging Charges */}
                                      <div className="pb-2">
                                        <div className="fw-bold text-uppercase text-muted">
                                          WhatsApp Messaging Charges
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Messages Sent to Users</span>
                                          <span>{item.message_count} Message(s)</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Charge per Message</span>
                                          <span>
                                            ₹ {twoDecimalPlaces(item.per_message_cost)}
                                          </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Subtotal (Message Charges)</span>
                                          <span>
                                            ₹ {twoDecimalPlaces(item.message_charges)}
                                          </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>GST (Tax)</span>
                                          <span>₹ {twoDecimalPlaces(item.message_gst)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between fw-bold">
                                          <span>Total Messaging Cost</span>
                                          <span>
                                            ₹{" "}
                                            {(
                                              parseFloat(item.message_charges || 0) +
                                              parseFloat(item.message_gst || 0)
                                            ).toFixed(2)}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="p-0 m-0" />

                                      {/* Transaction Charges */}
                                      <div className="py-2">
                                        <div className="fw-bold text-uppercase text-muted ">
                                          Transaction Charges
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Gateway Charges</span>
                                          <span>
                                            ₹ {twoDecimalPlaces(item.gateway_charges)}
                                          </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>GST</span>
                                          <span>₹ {twoDecimalPlaces(item.gateway_gst)}</span>
                                        </div>
                                      </div>
                                      <hr className="p-0 m-0" />

                                      {/* Platform Fee */}
                                      <div className="py-2">
                                        <div className="fw-bold text-uppercase text-muted ">
                                          Platform Fee
                                        </div>
                                        <div className="d-flex justify-content-between">
                                          <span>Platform Charges</span>
                                          <span>₹ {twoDecimalPlaces(item.charges)}</span>
                                        </div>
                                      </div>

                                      {item.order_type === "home_delivery" && (
                                        <>
                                          <hr className="p-0 m-0" />
                                          <div className="py-2">
                                            <div className="fw-bold text-uppercase text-muted ">
                                              Order Type : {item.order_type}
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <span>Delivery Fee</span>
                                              <span>
                                                ₹ {twoDecimalPlaces(item.delivery_fee)}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      )}

                                      <hr className="p-0 m-0" />
                                      <h6 className="py-4 d-flex justify-content-between fw-bold">
                                        <span className="text-primary">
                                          Total Charges Deduction
                                        </span>
                                        <span className="text-primary">
                                          ₹ {twoDecimalPlaces(item.totalDeduction)}
                                        </span>
                                      </h6>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))
                        )}
                      </tbody>
                    </table>

                    <div className="pb-4">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onNextPage={handleNextPage}
                        onPrevPage={handlePrevPage}
                        onPageClick={handlePageClick}
                      />
                    </div>
                  </>
                )}
                {activeTab === "un-successfullOrder" && (
                  <>
                    <table className="table table-hover">
                      <thead style={{ borderRadius: "10px" }}>
                        <tr
                          className="text-center"
                          style={{
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              borderRadius: "7px 0px 0px 7px",
                              fontSize: "0.95rem",
                            }}
                          >
                            S.No.
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Date
                          </th>

                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Order ID
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark single-line-css"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Customer Name
                          </th>
                          {/* <th
    className="p-3 align-middle bg-light text-dark"
    style={{
      color: "#fff",
      
      fontSize: "0.95rem",
    }}
  >
    Mode
  </th> */}

                          {/* <th
    className="p-3 align-middle bg-light text-dark"
    style={{
      color: "#fff",
      
      fontSize: "0.95rem",
    }}
  >
    Debit
  </th> */}

                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Message Send
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Per Message Cost
                          </th>
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              fontSize: "0.95rem",
                            }}
                          >
                            Toatl Message <br />
                            Charges Deduction
                          </th>
                          {/* <th
    className="p-3 align-middle bg-light text-dark"
    style={{
      color: "#fff",
      
      fontSize: "0.95rem",
    }}
  >
    GST
  </th> */}
                          {/* <th
    className="p-3 align-middle bg-light text-dark"
    style={{
      color: "#fff",
      
      fontSize: "0.95rem",
    }}
  >
   Net Settlement 
   <div>Amount</div>
   
  </th> */}
                          <th
                            className="p-3 align-middle bg-light text-dark"
                            style={{
                              color: "#fff",

                              borderRadius: "0px 7px 7px 0px",
                              fontSize: "0.95rem",
                            }}
                          >
                            Settlement
                            <br /> Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedItems.length === 0 ? (
                          <tr>
                            <td colSpan="10" className="text-center py-3">
                              No Payment Records Found for Selected Date !
                            </td>
                          </tr>
                        ) : (
                          displayedItems.map((item, index) => (
                            <tr
                              key={index}
                              style={{
                                borderBottom: "1px solid #DDD",
                                padding: "5px 0px",
                              }}
                            >
                              <td className="p-3 text-center align-middle">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td className="p-3 text-center align-middle">
                                {item.datetime}
                              </td>

                              <td className="p-3 text-center align-middle single-line-css">
                                {item.refrence}
                              </td>
                              <td className="p-3 text-center align-middle">
                                {item.customer_name || "NA"}
                              </td>

                              <td className="p-3 text-center align-middle">
                                {item.message_count} Message(s)
                              </td>
                              <td className="p-3 text-center align-middle">
                                ₹ {twoDecimalPlaces(item.per_message_cost)}
                              </td>
                              <td className="p-3 text-center align-middle">
                                ₹ {twoDecimalPlaces(item.message_charges)}
                              </td>

                              {/* <td className="p-3 text-center align-middle">
                            {item.tax_gst}
                          </td> */}
                              {/* <td className="p-3 text-center align-middle">
                            <strong>{item.settlement_amount}</strong>
                          </td> */}

                              <td className="p-3 text-center align-middle">
                                {item.settlement_status === "Y" ? (
                                  <span
                                    className="text-center w-100 d-inline-block px-3 py-1"
                                    style={{
                                      color: "#0F5132",
                                      backgroundColor: "#D1E7DD",
                                      border: "1px solid #0F5132",
                                      borderRadius: "20px",
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Settled
                                  </span>
                                ) : (
                                  <span
                                    className="text-center w-100 d-inline-block px-3 py-1"
                                    style={{
                                      color: "#000",
                                      backgroundColor: "#fff3cd",
                                      border: "1px solid #000",
                                      borderRadius: "20px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Unsettled
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                    <div className="pb-4">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onNextPage={handleNextPage}
                        onPrevPage={handlePrevPage}
                        onPageClick={handlePageClick}
                      />
                    </div>
                  </>
                )}
                {activeTab === "ProcessedSettlements" && (
                  <>
                 


                    <table className="table table-hover">
                      <thead>
                        <tr className="text-center">
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>S.No.</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>ID</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Invoice No</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Invoice Name</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>From</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>To</th>

                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Download</th>
                        </tr>
                      </thead>

                      <tbody>
                        {settlementInvoices.length === 0 ? (
                          <tr>
                            <td colSpan="8" className="text-center py-3">
                              No Settlement Invoices Found!
                            </td>
                          </tr>
                        ) : (
                          settlementInvoices.map((inv, index) => (
                            <tr key={index} className="text-center">
                              <td className="p-3 align-middle">{index + 1}</td>
                              <td className="p-3 align-middle fw-semibold">{inv.fk_userid}</td>
                              <td className="p-3 align-middle fw-semibold">{inv.invoice_number}</td>
                              <td className="p-3 align-middle fw-semibold">{inv.invoice_name}</td>
                              <td className="p-3 align-middle">{inv.from_date}</td>
                              <td className="p-3 align-middle">{inv.to_date}</td>


                              <td className="p-3 align-middle">
                                <a
                                  href={inv.invoice_url}
                                  download="invoice"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Download Invoice
                                </a>



                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </>
                )}

                {activeTab === "packky_assignment" && (
                  <>
                    <table className="table table-hover">
                      <thead>
                        <tr className="text-center">


                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>S.No.</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>From Date</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>To Date</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Message Charges</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Platform Charges</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Delivery Charges</th>



                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Net Processed Settlement Amount</th>


                        </tr>
                      </thead>
                      <tbody>
                        {displayedItems.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center py-3">
                              No Processed Settlements Records Found for Selected Date!
                            </td>
                          </tr>
                        ) : (
                          displayedItems.map((item, index) => (
                            <tr key={index} className="text-center">
                              <td className="p-3 align-middle">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                              <td className="p-3 align-middle">{item.from_date}</td>
                              <td className="p-3 align-middle">{item.to_date}</td>
                              <td className="p-3 align-middle">₹ {Number(item.messageCharges).toFixed(2)}</td>

                              <td className="p-3 align-middle">₹ {Number(item.platformCharges).toFixed(2)}</td>

                              <td className="p-3 align-middle">₹ {Number(item.deliveryCharges).toFixed(2)}</td>

                              <td className="p-3 align-middle text-success fw-bold">₹ {parseFloat(item.amount).toFixed(2)}</td>

                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>

                  </>
                )}
                {activeTab === "CampaigningCharge" && (
                  <>
                    <div className="isancharr-controls d-flex justify-content-start mb-1">
                      <div className="isancharr-whatsapp ">
                        <label className="isancharr-whatsapp-label single-line-css"> WhatsApp Number</label>
                        <select
                          className="isancharr-whatsapp-dropdown"
                          value={SingleWhatsApp}
                          onChange={(e) => setSingleWhatsApp(e.target.value)}
                          disabled={!MultiplePhoneNumber}
                        >
                          <option value="">Select Number</option>
                          {WhatsappNumbers.map((num, index) => (
                            <option key={index} value={num.phone_no_id}>
                              {num.phone_no_id} - ({num.phone_no})
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <table className="table table-hover">
                      <thead>
                        <tr className="text-center">


                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>S.No.</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Campaign ID</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Name</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Template</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Created On</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Submitted</th>



                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Cost</th>


                        </tr>
                      </thead>
                      <tbody>
                        {Campaign.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center py-3">
                              No Campaign has been found to this Date!
                            </td>
                          </tr>
                        ) : (
                          Campaign.map((item, index) => (
                            <tr key={index} className="text-center">
                              <td className="p-3 align-middle">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                              <td className="p-3 align-middle"><b>ID-{item.id}</b></td>
                              <td className="p-3 align-middle">{item.campaign_name}</td>
                              <td className="p-3 align-middle">{item.template_id}</td>
                              <td className="p-3 align-middle">{item.campaign_start}</td>

                              <td className="p-3 align-middle">{twoDecimalPlaces(item.submitted) || "N/A"}</td>
                              <td className="p-3 align-middle">₹{twoDecimalPlaces(item.estimatedCost) || "N/A"}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>

                  </>
                )}
                {activeTab === "refund_report" && (
                  <>
                    <table className="table table-hover">
                      <thead>
                        <tr className="text-center">
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>#</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>VA Account</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Sender Acc</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Created On</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Status</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Amount</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Bank RRN</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Mode</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Order ID</th>
                          <th className="p-3 align-middle bg-light text-dark" style={{ fontSize: "0.95rem" }}>Customer Mobile</th>
                        </tr>
                      </thead>
                      <tbody>
                        {refund_report.length === 0 ? (
                          <tr>
                            <td colSpan="10" className="text-center py-3">
                              No Campaign has been found to this Date!
                            </td>
                          </tr>
                        ) : (
                          refund_report.map((item, index) => (
                            <tr key={index} className="text-center">
                              <td className="p-3 align-middle">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                              <td className="p-3 align-middle">{item.va_account}</td>
                              <td className="p-3 align-middle">{item.sender_acc || "N/A"}</td>
                              <td className="p-3 align-middle">{item.created_on}</td>
                              <td className="p-3 align-middle">{item.status || "N/A"}</td>
                              <td className="p-3 align-middle">₹{Number(item.amount).toFixed(2)}</td>
                              <td className="p-3 align-middle">{item.bank_rrn || "N/A"}</td>
                              <td className="p-3 align-middle">{item.mode || "N/A"}</td>
                              <td className="p-3 align-middle">{item.order_id || "N/A"}</td>
                              <td className="p-3 align-middle">{item.customer_mobile || "N/A"}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </>

                )}

              </>
            )}
          </div>
        </div>

<WalletTransactionModal
  show={showWalletTxnModal}
  onHide={() => setShowWalletTxnModal(false)}
  userID={userID}
  baseUrl={baseUrl}
  BASIC_AUTH={BASIC_AUTH}
/>


      </div>
      <style>
        {`
          /* Equal spacing & subtle separators for the third card */
          .admin-metric-3 {
            gap: 0.75rem;           /* breathing room without changing card width/height */
            align-items: stretch;
          }

          .admin-metric-3 > .flex-fill {
            padding: 0 .5rem;
          }

          .admin-divider-x {
            width: 1px;
            background: rgba(0,0,0,0.08); /* subtle divider that works on light/dark text */
            margin: 0 .25rem;
          }
            :root {
  --admin-green: #01c27d;
  --admin-blue:  #00c9ff;
  --admin-red:   #fd5858;
  --admin-text:  #212529;
  --admin-muted: #6c757d;
}

/* Wrapper grid */
.admin-mini-wrap {
  /* uses Bootstrap gap-2; add min width handling */
}

/* Card base */
.admin-mini-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  min-width: 180px;      /* feels “tiny” but readable */
  max-width: 240px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(0,0,0,0.06);
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
}

/* Tone tints */
.admin-mini-net   { background: rgba(0,201,255,0.08);  border-color: rgba(0,201,255,0.20); }
.admin-mini-credit{ background: rgba(1,194,125,0.08);  border-color: rgba(1,194,125,0.20); }
.admin-mini-debit { background: rgba(253,88,88,0.08);  border-color: rgba(253,88,88,0.20); }

/* Top row */
.admin-mini-top {
  display: flex;
  align-items: center;
  gap: 48px;
}
.admin-mini-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: rgba(0,0,0,0.06);
}
.admin-mini-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--admin-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Bottom row */
.admin-mini-bottom {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.admin-mini-amount {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--admin-text);
}

.admin-mini-type {
  font-size: 0.68rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  letter-spacing: 0.2px;
  border: 1px solid transparent;
  background: rgba(0,0,0,0.04);
  color: var(--admin-muted);
}
.admin-mini-type--net {
  background: rgba(0,201,255,0.14);
  color: #03657a;
  border-color: rgba(0,201,255,0.25);
}
.admin-mini-type--credit {
  background: rgba(1,194,125,0.14);
  color: #065f46;
  border-color: rgba(1,194,125,0.25);
}
.admin-mini-type--debit {
  background: rgba(253,88,88,0.14);
  color: #7a1f1f;
  border-color: rgba(253,88,88,0.25);
}

/* Icon sizing consistency */
.admin-mini-card svg { flex: 0 0 auto; }

        `}
      </style>
    </>

  );
};

export default Payment;
